export class JurisdictionSettings {
    public jurisdiction: string;
    public isSignedEFileRequired: boolean;
    public isExpectingDeclarationWithinEFile: boolean;
    public isJurisdictionTaxNumberRequired: boolean;
}